import { TEDCApplicant } from "@smvtech/x-flux";
import QuestionsList from "pages/EDCFlow/components/VisaForm/QuestionsList";

type Props = {
	activeApplicantData: TEDCApplicant;
};

const FormList = ({ activeApplicantData }: Props) => {
	return (
		<div className="px-4 py-6 pb-28">
			<QuestionsList activeApplicantData={activeApplicantData} />
		</div>
	);
};

export default FormList;

